var map = {
	"./auditoria/auditoria.module": [
		"./src/app/auditoria/auditoria.module.ts",
		"common",
		"auditoria-auditoria-module"
	],
	"./cadastro/cadastro.module": [
		"./src/app/cadastro/cadastro.module.ts",
		"cadastro-cadastro-module~gerenciamento-gerenciamento-module",
		"common",
		"cadastro-cadastro-module"
	],
	"./gerenciamento/gerenciamento.module": [
		"./src/app/gerenciamento/gerenciamento.module.ts",
		"cadastro-cadastro-module~gerenciamento-gerenciamento-module",
		"common",
		"gerenciamento-gerenciamento-module"
	],
	"./relatorios/relatorios.module": [
		"./src/app/relatorios/relatorios.module.ts",
		"common",
		"relatorios-relatorios-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;